module.exports = __webpack_public_path__ + "static/media/lyrics.b44b3d0d.svg";